"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlindedCommitmentForShield = exports.getBlindedCommitmentForTransact = exports.getBlindedCommitmentForUnshield = void 0;
const circomlibjs_1 = require("circomlibjs");
const bytes_1 = require("../utils/bytes");
const formatHash = (hash) => {
    return `0x${(0, bytes_1.nToHex)(hash, bytes_1.ByteLength.UINT_256)}`;
};
const getBlindedCommitmentForUnshield = (commitmentHash, toAddress, railgunTxid) => {
    const hash = (0, circomlibjs_1.poseidon)([commitmentHash, toAddress, railgunTxid].map((x) => (0, bytes_1.hexToBigInt)(x)));
    return formatHash(hash);
};
exports.getBlindedCommitmentForUnshield = getBlindedCommitmentForUnshield;
const getBlindedCommitmentForTransact = (commitment, npk, railgunTxid) => {
    const hash = (0, circomlibjs_1.poseidon)([(0, bytes_1.hexToBigInt)(commitment.hash), npk, (0, bytes_1.hexToBigInt)(railgunTxid)]);
    return formatHash(hash);
};
exports.getBlindedCommitmentForTransact = getBlindedCommitmentForTransact;
const getBlindedCommitmentForShield = (commitmentHash, npk, shieldRailgunTxid) => {
    const hash = (0, circomlibjs_1.poseidon)([(0, bytes_1.hexToBigInt)(commitmentHash), npk, (0, bytes_1.hexToBigInt)(shieldRailgunTxid)]);
    return formatHash(hash);
};
exports.getBlindedCommitmentForShield = getBlindedCommitmentForShield;
